import { globalAdminFieldSchemeEntryPoint } from '@jira/admin-pages__field-scheme/src/globalAdminFieldSchemeEntryPoint.entrypoint.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalSettingsIssueFieldSchemeRoute } from '@jira/router-routes__admin-pages-field-schemes-routes/src/globalSettingsIssueFieldSchemeRoute.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: globalAdminFieldSchemeEntryPoint,
});

export const globalSettingsIssueFieldSchemeRouteEntry: Route = createEntry(
	globalSettingsIssueFieldSchemeRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.field-scheme',
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		canTransitionIn: () => !fg('mc-nfa-soft-rollback'),

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		entryPoint: () => {
			if (fg('mc-nfa-soft-rollback')) {
				return undefined;
			}

			return pageEntryPoint;
		},

		meta: {
			reporting: {
				packageName: 'jiraAdminPagesFieldScheme',
				id: 'globalSettingsIssueFieldScheme',
				teamName: 'Yamato',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
